export const constants = {
  enqueueSnackbar: 'snack.enqueue_snackbar',
  closeSnackbar: 'snack.close_snackbar',
  removeSnackbar: 'snack.remove_snackbar',
};

export const enqueueSnackbar = notification => {
  const key = notification.options && notification.options.key;

  return {
    type: constants.enqueueSnackbar,
    notification: {
      ...notification,
      key: key || new Date().getTime() + Math.random(),
    },
  };
};

export const closeSnackbar = key => ({
  type: constants.closeSnackbar,
  dismissAll: !key,
  key,
});

export const removeSnackbar = key => ({
  type: constants.removeSnackbar,
  key,
});

export const actions = {
  enqueueSnackbar,
  closeSnackbar,
  removeSnackbar,
};
